import React from "react";

export default function DashboardShell({ left, top, children }) {
  return (
    <div
      className="dash-shell"
      style={{
        display: "grid",
        gridTemplateColumns: "280px minmax(0, 1fr)",
        gap: 12,
        alignItems: "start",
      }}
    >
      <aside
        className="dash-left"
        style={{
          position: "sticky",
          top: 72,
          height: "calc(100vh - 92px)",
          overflow: "auto",
          padding: 12,
          border: "1px solid rgba(255,255,255,0.10)",
          borderRadius: 14,
          background: "rgba(255,255,255,0.03)",
          minWidth: 0,
        }}
      >
        {left}
      </aside>

      <main className="dash-right" style={{ minWidth: 0 }}>
        {top ? <div className="dash-top" style={{ marginBottom: 12 }}>{top}</div> : null}
        <div className="dash-body" style={{ minWidth: 0 }}>{children}</div>
      </main>
    </div>
  );
}
